import { render, staticRenderFns } from "./XXXTab.vue?vue&type=template&id=01993055&scoped=true"
import script from "./XXXTab.vue?vue&type=script&lang=js"
export * from "./XXXTab.vue?vue&type=script&lang=js"
import style0 from "./XXXTab.vue?vue&type=style&index=0&id=01993055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01993055",
  null
  
)

export default component.exports